const newsletterForm = class extends HTMLElement {
  constructor() {
    super()

    this.apiKey = this.dataset.apiKey
    this.listId = this.dataset.listId
    this.customSource = this.dataset.customSource
    this.type = this.dataset.type

    this.form = this.querySelector('[data-newsletter-form]')
    this.emailField = this.querySelector('input[name="email"]')
    this.fields = this.querySelectorAll('.field')

    this.success = this.querySelector('.success_message')
    this.error = this.querySelector('.error_message')

    this.form && this.form.addEventListener('submit', (e) => {
      e.preventDefault()

      if (!this.emailField.checkValidity()) {
        this.error.classList.remove('hide')
        this.error.innerHTML = `<p>Please enter a valid email address.</p>`
        return
      }

      this.submitForm()
    })
  }

  async submitForm() {
    const formData = {
      data: {
        type: this.type,
        attributes: {
          ...(this.customSource) && {
            custom_source: this.customSource
          },
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: this.emailField.value
              }
            }
          }
        },
        subscriptions: {
          email: {
            marketing: {
              consent: 'SUBSCRIBED'
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: this.listId
            }
          }
        }
      }
    }

    const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.apiKey}`, {
      method: 'POST',
      headers: {
        revision: '2024-02-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify(formData)
    })

    this.success && this.success.classList.toggle('hide', !res.ok)
    this.fields.forEach((field) => {
      field.classList.toggle('hide', res.ok)
    })

    if (this.error) {
      this.error.classList.toggle('hide', res.ok)
      this.error.innerHTML = `<p>${res.statusText}</p>`
    }

    if (!res.ok) { return }
    const successEvent = new CustomEvent('submit_success', {
      detail: res
    })

    this.dispatchEvent(successEvent)
  }
}

if (typeof window.customElements.get('newsletter-form') === 'undefined') {
  window.customElements.define('newsletter-form', newsletterForm)
}
